import type { StatusChipVariant } from '@/components/ui/status-chip';

// Legacy statusColor() mapped onto StatusChip variants. Requests use start|pause|stop;
// statuses come back as ready|starting|paused|stopped|error (+ possibly others).
const STATUS_VARIANTS: Record<string, StatusChipVariant> = {
  ready: 'success',
  starting: 'info',
  paused: 'warning',
  stopped: 'muted', // legacy: grey
  error: 'destructive', // legacy: error/red
};

export const makerStatusVariant = (status: string): StatusChipVariant => STATUS_VARIANTS[status] ?? 'muted';

// StatusChip has no primary/purple variants — className overrides win over the
// variant classes via cn's tailwind-merge.
export const PRIMARY_CHIP_CLASS = 'border-primary/40 bg-primary/10 text-primary';
export const PURPLE_CHIP_CLASS = 'border-purple-500/40 bg-purple-500/10 text-purple-400';
